import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Producer, ProducerSummary } from './producer';
import { BaseIndexedDbRepository } from 'libs/arch/src/lib/repositories/indexed-db/indexdb-repository';
import { SynchronizationService } from 'libs/arch/src/lib/repositories/indexed-db/synchronization.service';
import { ApiService } from '@homeleite/arch';

@Injectable({ providedIn: 'root' })
export class ProducersRepository extends BaseIndexedDbRepository<ProducerSummary, Producer> {

    protected mapToEntity(dbItem: Producer): Producer {
        return Producer.fromJson(dbItem);
    }

    protected override readonly storeName: string = 'producers';

    protected override getResourcePath(): string {
        return 'producers';
    }

    protected override getSearchableFields(): string[] {
        return ['name', 'code'];
    }

    protected override mapToSummary(item: Producer): ProducerSummary {
        if (!item) return null as any;
        return new ProducerSummary(
            item.id,
            item.name,
            item.code
        );
    }

    constructor(
        dbService: NgxIndexedDBService,
        synchronizationService: SynchronizationService,
        private apiService: ApiService
    ) {
        super(dbService, synchronizationService);
    }


}
